<template>
  <div class="javaHomeModular">
    <navBarNoLab :onIndex="0"></navBarNoLab>
    <div class="javaContent">
      <div class="banner" v-if="bannerInfo">
        <div class="video">
          <!-- <video class="javaVideo" autoplay loop muted>
            <source
              class="javaSource"
              src="./images/img/banner_video.mp4"
              type="video/mp4"
            />
          </video> -->
          <div class="bannerfont">
            <!-- <div><img src="./images/img/baner_font.png" width="775px" alt=""/></div> -->
            <div
              class="playRow"
              @click="
                handleVideo('https://v.itheima.net/pip-java-index/oSSYVO.mp4')
              "
            >
              <!-- <img src="./images/img/baner_font2.png" width="420px" alt=""/> -->
              <div class="banPlayBut">
                <img
                  src="../../../../assets/btn_play_ban.png"
                  width="27px"
                  alt=""
                />
                查看需求文档
              </div>
            </div>
          </div>
        </div>

        <!-- <div :style="`background-image:url(${bannerInfo.banner.length > 0 ? bannerInfo.banner[0].url : ''})`"></div> -->
        <!-- <div class="infoCont">
          <div class="banTit">{{bannerInfo.title}}</div>
          <div class="banCont">{{bannerInfo.url}}</div>
        </div> -->
        <div class="labelCont">
          <div
            class="labelItem"
            v-for="(item, index) in bannerInfo.contListDataes"
            :key="index"
          >
            <img
              v-if="item.image"
              :src="item.image[0].url"
              width="32px"
              alt=""
            />
            {{ item.title }}
            <i
              >{{ index == 0 ? numberA : index == 1 ? numberB : numberC
              }}<span v-show="index == 1 || index == 0">+ </span
              ><span v-show="index == 2">W+ </span></i
            >
          </div>
        </div>
      </div>
      <div
        id="scrollTg6"
        class="screen objectList"
        style="padding-top: 70px"
        v-if="objectListdata && objectListdata.length > 0"
      >
        <div class="centent">
          <div class="title" v-if="objectListdata.length > 0">
            JAVA<!-- {{objectListdata.length}}个 -->行业真项目，快速体验
          </div>
          <div class="cont">
            <div class="objectItems">
              <div class="labCont">
                <div
                  class="item"
                  :class="{ active: index === objectIndex }"
                  v-for="(item, index) in objectListdata"
                  :key="index"
                  @click="objectHandle(item, index)"
                >
                  {{ item.title }}
                </div>
              </div>
              <div class="objCont">
                <div class="objBaseInfo" :key="objectIndex">
                  <div class="logo">
                    <img
                      v-if="objectInfoData.banner.length > 0"
                      :src="objectInfoData.banner[0].url"
                      alt=""
                    />
                  </div>
                  <div class="info">
                    <div>{{ objectInfoData.info }}</div>
                    <div class="label" v-if="objectInfoData.BotTitle">
                      <span
                        v-for="(item, index) in objectInfoData.BotTitle.split(
                          '|'
                        )"
                        :key="index"
                        >{{ item }}</span
                      >
                    </div>
                  </div>
                  <div class="button" @click="goDetails(objectInfoData)">
                    <span class="anim"></span>
                    <img src="./images/img/icon_tiyan.png" alt="" />
                    立即体验
                  </div>
                </div>
                <div class="rollBox">
                  <div
                    class="rollBar"
                    v-if="
                      objectInfoData.contListDataes &&
                      objectInfoData.contListDataes.length >= 2
                    "
                  >
                    <div
                      class="leftBar"
                      :class="{ noHandle: rollItemIndex == 0 }"
                      @click="carouselhandle('red')"
                    >
                      <i class="icon iconfont iconicon_more_sel2x"></i>
                    </div>
                    <div class="labBar">
                      <span
                        :class="{ act: index === rollItemIndex }"
                        v-for="(item, index) in objectInfoData.contListDataes"
                        :key="index"
                        @click="() => (rollItemIndex = index)"
                      ></span>
                    </div>
                    <div
                      class="rightBar"
                      :class="{
                        noHandle:
                          rollItemIndex ==
                          objectInfoData.contListDataes.length - 1,
                      }"
                      @click="carouselhandle('add')"
                    >
                      <i class="icon iconfont iconicon_more_sel2x"></i>
                    </div>
                  </div>
                  <div class="rollCont">
                    <div class="scrollCont" :style="programCroll">
                      <div
                        class="scrollImg"
                        v-for="(it, ind) in objectInfoData.contListDataes"
                        :key="ind"
                        :class="{
                          current: ind == rollItemIndex,
                          prevCurrent: ind == rollItemIndex - 1,
                          nextCurrent: ind == rollItemIndex + 1,
                          prevNode: ind < rollItemIndex - 1,
                          nextNode: ind > rollItemIndex + 1,
                        }"
                        @click="carouselhandle('add', ind)"
                      >
                        <img
                          v-if="it.ButtonImage.length > 0"
                          :src="it.ButtonImage[0].url"
                          width="300px"
                          alt=""
                        />
                        <div
                          class="objPlay"
                          v-if="it.url"
                          @click="handleVideo(it.url)"
                        >
                          <img
                            src="./images/img/icon_play2.png"
                            width="60px"
                            alt=""
                          />
                        </div>
                        <div class="rollFloatIcon">
                          <div class="iconbox">
                            <img
                              v-if="it.image"
                              :src="it.image[0].url"
                              width="30px"
                              alt=""
                            />
                          </div>
                          <div>{{ it.title }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modelTg2">
        <div class="title">职场老手教你如何分辨「真假」项目课程</div>
        <div class="subTitle">能够分辨，才能学到真项目，才能找到好工作</div>
        <div class="contTitBox">
          <div class="titlelab">
            <div>真项目</div>
            <div>假项目</div>
          </div>
          <div class="cont">
            <div class="leftItem">
              <div class="item" v-for="item in realObjData" :key="item">
                {{ item }}
              </div>
            </div>
            <div class="rightItem">
              <div class="item" v-for="item in fakeObjData" :key="item">
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div class="bgLeftImg">
          <img src="./images/img/bg_left_img.png" alt="" />
        </div>
        <div class="bgRitImg">
          <img src="./images/img/bg_rit_img.png" alt="" />
        </div>
      </div>
      <div class="blueRowTit">完整还原企业项目，倾力打造“真项目”</div>
      <div class="containerBox" id="scrollTag">
        <div class="navLaftFloat floatState" :style="floatPosit">
          <div
            :class="{ item: true, act: index === floatTag }"
            v-for="(item, index) in floatData"
            :key="index"
            @click="scrollTagHandle(index)"
          >
            <i :class="item.icon"></i> {{ item.title }}
          </div>
        </div>
        <!-- 高覆盖 -->
        <div class="highCoverage">
          <HomeTitle
            title="50+大型行业项目，满足不同行业就业需求"
            subTitle="项目持续增加，实时响应市场变化，帮助学员在家门口“就进”就业"
          ></HomeTitle>
          <div class="highCoverageCont">
            <img src="./images/img/img_highCoverage.png" width="100%" alt="" />
          </div>
        </div>
        <!-- 快更新 -->
        <div class="QuickUpdate" id="scrollTg1">
          <HomeTitle
            title="项目课程以「周」为单位，根据市场变化、技术迭代、教学反馈，持续更新"
            subTitle="教学内容、技术应用，皆在千锤百炼中不断打磨，让你成为企业的中流砥柱"
          ></HomeTitle>
          <div class="QuickUpdateCont">
            <div class="QuickUpdateBox">
              <div class="topTitle">
                <div class="tit">
                  <span>课程项目更新情况</span>（ 2020.7-2023.11 / 数据来源于
                  Git ）
                </div>
                <div class="desc">项目提交代码次数</div>
              </div>
              <div class="scrollBox">
                <swiper
                  :options="swiperOption"
                  style="width: calc(100% - 20px)"
                >
                  <swiper-slide
                    ><img src="./images/img/roll1.jpeg" width="100%" alt=""
                  /></swiper-slide>
                  <swiper-slide
                    ><img src="./images/img/roll2.jpeg" width="100%" alt=""
                  /></swiper-slide>
                  <swiper-slide
                    ><img src="./images/img/roll3.png" width="100%" alt=""
                  /></swiper-slide>
                  <swiper-slide
                    ><img src="./images/img/roll4.png" width="100%" alt=""
                  /></swiper-slide>
                </swiper>
                <div class="swiper-pagination" slot="pagination"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 真业务 -->
        <div class="RealBusiness" id="scrollTg2">
          <HomeTitle
            title="业务源自大型互联网公司的真实需求"
            subTitle="业务决定技术，“真业务”造就真技术，真技术才能成就“真就业”"
          ></HomeTitle>
          <div class="RealBusinessCont">
            <div class="realContTop">
              <img
                src="./images/img/img_RealBusiness.png"
                style="display: block"
                width="100%"
                alt=""
              />
            </div>
            <div class="realCont">
              <div class="title">欢迎品鉴真项目业务需求</div>
              <div class="itemlist">
                <div class="listLeft">
                  <div
                    class="lists"
                    v-for="(item, index) in realContBotListDataes"
                    :key="index"
                    @click="openFileHandle(item.url)"
                  >
                    <div><i class="icon iconfont" :class="item.icon"></i></div>
                    <div>{{ item.title }}</div>
                  </div>
                </div>
                <div class="realContVidCont">
                  <!-- <img src="./images/img/bg_video_real.png" width="459px" alt=""> -->
                  <div
                    class="vidInfo"
                    @click="
                      handleVideo(
                        'https://v.itheima.net/pip-java-index/oSSYVO.mp4'
                      )
                    "
                  >
                    <img
                      src="./images/img/icon_play_real.png"
                      width="47"
                      alt=""
                    />
                    <div>
                      <p>快速浏览</p>
                      <p>全部项目需求</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 好就业 -->
        <!-- <div class="GoodEmployment" id="scrollTg3">
            <HomeTitle title="想要成为“高新”，「从0到1」项目是基础，「从1到2」项目是必备" subTitle='让学员满足「不同发展阶段企业」所需技能要求'></HomeTitle>
            <div class="QuickUpdateCont">
              <img src="./images/img/img_QuickUpdate.png" width="100%" alt="">
            </div>
          </div> -->
        <!-- 真方案 -->
        <div class="TruePlan" id="scrollTg3">
          <HomeTitle
            title="30+解决方案，快速搞定工作难题"
            subTitle="相同的工作场景，开发不必从零开始，方案拿来即用，让你成为团队中问题解决小能手"
          ></HomeTitle>
          <div class="TruePlanCont">
            <div class="TruePlanBox">
              <div class="TruePlanLeft">
                <div
                  :class="{ item: true, active: TruePlanSt === index }"
                  @click="() => (TruePlanSt = index)"
                  v-for="(item, index) in TruePlanDataes"
                  :key="index"
                >
                  <div class="title">{{ item.title }}</div>
                  <div class="desc">{{ item.subTitle }}</div>
                </div>
              </div>
              <div class="TruePlanRight">
                <div
                  class="itemCont"
                  :class="{
                    scrollShow: TruePlanDataes[TruePlanSt].content.length > 9,
                  }"
                >
                  <div
                    class="list"
                    v-for="(item, index) in TruePlanDataes[TruePlanSt].content"
                    :key="index"
                    @mouseover="() => (showDescInd = index)"
                    @mouseout="() => (showDescInd = '')"
                  >
                    <!-- <div class="tit">{{item.title}}</div>
                          <div class="desc" :title="item.desc" >{{cutstr(item.desc, 28)}}</div>
                          <div class="showAll" v-show="showDescInd === index">{{item.desc}}</div> -->
                    <el-popover
                      placement="top-start"
                      width="200"
                      trigger="hover"
                      :content="item.desc"
                    >
                      <div slot="reference">
                        <div class="tit">{{ item.title }}</div>
                        <div class="desc">{{ cutstr(item.desc, 28) }}</div>
                      </div>
                    </el-popover>
                  </div>
                </div>
              </div>
            </div>
            <div class="retouch">
              <img src="./images/img/ret_play.png" width="62" alt="" />
            </div>
          </div>
        </div>
        <!-- 真实战 -->
        <div class="RealWar" id="scrollTg4">
          <HomeTitle
            title="学员项目实战全纪录"
            subTitle="学以致用、独立编码、团队协作，助力就业临门一脚"
          ></HomeTitle>
          <div class="RealWarCont">
            <div class="mudSubTitle">{{ driedLabelData.title }}</div>
            <div class="driedlabel" v-if="driedLabelData">
              <div
                class="driedLabelBox"
                v-for="(item, index) in driedLabelData.driedLabeList"
                :key="index"
              >
                <div class="iconImg">
                  <img :src="item.iconImg[0].url" alt="" />
                </div>
                <div class="line"></div>
                <div class="descCont">
                  <div class="fontIcon">{{ `0${index + 1}` }}</div>
                  <div class="text">
                    <p>{{ item.desc[0] }}</p>
                    <p>{{ item.desc[1] }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="bigVideoCont">
              <div class="RealWarvidCont">
                <img src="./images/img/bg_video.png" width="100%" alt="" />
                <div
                  class="RealWarvidContInfo"
                  @click="
                    handleVideo(
                      'https://v.itheima.net/pip-java-index/D8tAoE.mp4'
                    )
                  "
                >
                  <img
                    src="./images/img/icon_play_real.png"
                    width="47"
                    alt=""
                  />
                  <div>
                    <p>学员实战过程全记录</p>
                    <p class="desc">
                      <span style="margin-right: 10px">面向对象面向君</span>
                      不负代码不负卿
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="mudSubTitle">学员实战答辩报告集</div>
            <div class="videoListCont">
              <div class="vidContent">
                <div class="vidbox">
                  <div class="topVidA">
                    <div class="vidListItem">
                      <img
                        src="./images/img/bg_video3.jpg"
                        width="100%"
                        alt=""
                      />
                      <div class="play">
                        <img
                          src="./images/img/icon_play.png"
                          width="20px"
                          @click="
                            handleVideo(
                              'https://v.itheima.net/pip-java-index/UdNxWO.mp4'
                            )
                          "
                        />
                        <div class="tite">广州Java146期学员</div>
                        <div class="subt">探花交友项目实战答辩</div>
                      </div>
                    </div>
                    <div class="vidListItem">
                      <img
                        src="./images/img/bg_video2.jpg"
                        width="100%"
                        alt=""
                      />
                      <div class="play">
                        <img
                          src="./images/img/icon_play.png"
                          width="20px"
                          @click="
                            handleVideo(
                              'https://v.itheima.net/pip-java-index/Th100t.mp4'
                            )
                          "
                        />
                        <div class="tite">上海Java148期学员</div>
                        <div class="subt">传智健康项目实战答辩</div>
                      </div>
                    </div>
                  </div>
                  <div class="topVidB">
                    <div class="vidListItem">
                      <img
                        src="./images/img/bg_video1.jpg"
                        width="100%"
                        alt=""
                      />
                      <div class="play">
                        <img
                          src="./images/img/icon_play.png"
                          width="20px"
                          @click="
                            handleVideo(
                              'https://v.itheima.net/pip-java-index/qo2qcN.mp4'
                            )
                          "
                        />
                        <div class="tite">天津Java149期学员</div>
                        <div class="subt">探花交友项目实战答辩</div>
                      </div>
                    </div>
                    <div class="vidListItem">
                      <img
                        src="./images/img/bg_video4.jpg"
                        width="100%"
                        alt=""
                      />
                      <div class="play">
                        <img
                          src="./images/img/icon_play.png"
                          width="20px"
                          @click="
                            handleVideo(
                              'https://v.itheima.net/pip-java-index/s8Zp5d.mp4'
                            )
                          "
                        />
                        <div class="tite">天津Java149期学员</div>
                        <div class="subt">车服管家项目实战答辩</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rit vidListItem">
                  <img src="./images/img/bg_video5.jpg" width="100%" alt="" />
                  <div class="play">
                    <img
                      src="./images/img/icon_play.png"
                      width="20px"
                      @click="
                        handleVideo(
                          'https://v.itheima.net/pip-java-index/DI1AHG.mp4'
                        )
                      "
                      alt=""
                    />
                    <div class="tite">北京Java150期学员</div>
                    <div class="subt">SaaS-Export 项目实战答辩</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg8" class="screen sNine">
        <div class="centent" v-if="ninthScreen">
          <div class="title">{{ ninthScreen.title }}</div>
          <div class="cont">
            <div
              class="items"
              v-for="(item, index) in ninthScreen.contListDataes"
              :key="index"
            >
              <div class="info">
                <img
                  v-if="item.image && item.image.length > 0"
                  :src="item.image[0].url"
                  width="40px"
                  alt=""
                />
                <div class="ritInfo">
                  <div class="name">{{ item.title }}</div>
                  <div class="time">{{ item.subTitle }}</div>
                </div>
              </div>
              <div class="des">
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
    <MenuListAdd ref="editMenuList"></MenuListAdd>
    <el-dialog :visible.sync="dialogVisible" width="80%">
      <div class="close_ico" @click="() => (dialogVisible = false)">
        <img src="./images/close.png" width="100%" alt="" />
      </div>
      <div class="JavaHomeSwiper">
        <swiper :options="options" style="width: calc(100% - 20px)">
          <swiper-slide
            ><img src="./images/img/roll1.jpeg" width="100%" alt=""
          /></swiper-slide>
          <swiper-slide
            ><img src="./images/img/roll2.jpeg" width="100%" alt=""
          /></swiper-slide>
          <swiper-slide
            ><img src="./images/img/roll3.png" width="100%" alt=""
          /></swiper-slide>
          <swiper-slide
            ><img src="./images/img/roll4.png" width="100%" alt=""
          /></swiper-slide>
        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </div>
    </el-dialog>
    <bottom-widge></bottom-widge>
  </div>
</template>

<script>
import navBarNoLab from './../../../components/navBarNoLab';
import bottomWidge from './../../../components/bottomWidge';
import { Contents } from '../../../../gqlapi/Contents.js';
import { JavaHome } from '../../../../gqlapi/JavaHome.js';
import MenuAdd from './../../../components/video';
import MenuListAdd from './../../../components/videoList';
import HomeTitle from './components/HomeTitle';
import { CutString } from './../../../../utils/tools';
export default {
  name: 'layout',
  components: {
    navBarNoLab,
    bottomWidge,
    MenuAdd,
    MenuListAdd,
    HomeTitle,
  },
  data() {
    return {
      dialogVisible: false,
      bannerInfo: {},
      screenWidth: 1210,
      rollItemIndex: 0,
      showDescInd: '',
      realObjData: [
        '1.完整体验：可商用的产品设计、技术实现',
        '2.符合企业需求的部署、测试与运维监控',
        '3“周”单位依据市场需求及教学反馈，持续优化',
        '4.课程天数≥10，功能数>30，页面数>10',
        '5.项目配套文档，一应俱全！',
      ],
      fakeObjData: [
        '1.文字游戏，只能预览图片，鲜少能体验',
        '2.项目不维护、不更新，bug数＞功能数',
        '3.技术过时，系统老旧，从不更新',
        '4.课程天数<10，功能数<30，页面数<10',
        '5.需求文档、开发文档等，全无！',
      ],
      driedLabelData: {
        title: '项目实战收获干货',
        videoUrl: {
          url: '',
        },
        driedLabeList: [
          {
            iconImg: [{ url: require('./images/img/icon_work.png') }],
            desc: ['积累工作经验', '便于面试就业'],
          },
          {
            iconImg: [{ url: require('./images/img/icon_lichen.png') }],
            desc: ['体验工作流程', '适应职场节奏'],
          },
          {
            iconImg: [{ url: require('./images/img/icon_rail.png') }],
            desc: ['转换菜鸟角色', '真实开发经历'],
          },
          {
            iconImg: [{ url: require('./images/img/icon_loophole.png') }],
            desc: ['发现知识漏洞', '弥补经验不足'],
          },
          {
            iconImg: [{ url: require('./images/img/icon_communicate.png') }],
            desc: ['锻炼沟通表达', '提高合作能力'],
          },
        ],
      },
      TruePlanSt: 0,
      TruePlanDataes: [
        {
          title: '通用型解决方案',
          subTitle: '技术的万金油，一个方案解决n多业务问题',
          content: [
            {
              title: '亿级缓存解决方案',
              desc: '缓存一直是提升系统性能的重要方式，如何进行亿级数据的缓存是评价程序员技术水平高低的一个重要因素，本方案采用分布式分片缓存技术，轻松存储亿级数据，达到海量数据即时查找和存储的目的。',
            },
            {
              title: '多数据源解决方案',
              desc: '软件系统性能瓶颈的一个重要原因是数据库的并发能力限制，读写分离是解决此问题的 一个重要方法。本方案采用AOP技术，实现同一应用对接多个数据源，完成数据库的读写分离，减轻数据库IO读写压力，能够有效提高软件系统的并发能力。',
            },
            {
              title: '数据同步解决方案',
              desc: '软件系统出于安全、性能和分析的目的，经常将不同数据库中的数据进行同步，如异地灾备、聚合查询，数据分析等场景，本方案使用alibaba canal框架实现多个数据源、数据库表的准秒级同步功能。',
            },
            {
              title: '分库分表解决方案',
              desc: '对于高频率操作的系统，如交易、订单等，单表数据量会非常大，此时系统性能会直线下降，主流解决方案除了读写分离，另外一个途径是分库分表。本方案采用Mycat框架，按照不同的数据分片规则，将数据库进行分库分表操作，应用端开发无任何改动，如同操作一个数据库，从而有效降低数据库访问压力、提高系统性能。',
            },
            {
              title: 'PB级搜索解决方案',
              desc: '对于电商类（B2B、B2C、C2C）等系统，如何让用户快速查询到目标商品是一个重要课题，也是系统成败的关键因素之一。本方案采用分布式开源搜索和分析引擎elasticsearch技术实现，它能够水平扩展，每秒钟可处理海量事件，同时能够自动管理索引和查询在集群中的分布方式，以实现流畅的操作。广泛应用于电商、互联网应用、分布式日志存储。',
            },
            {
              title: '海量大数据存储方案',
              desc: '物联网、互联网系统在生产环境中会产生海量的数据，如设备状态、预警信息、访问日志等，这些数据对于业务和分析具有重要的作用；同时，作为一个java工程师，懂得一些大数据技术在将会有更大的优势。本方案采用influxdb技术，能够高效存储和查询海量数据，并具有足够的容错性和稳定性。',
            },
            {
              title: '热数据处理与淘汰方案',
              desc: '数据的存储和使用是程序员要面对的重要问题，对于大多数互联网系统，如何进行数据的分级（冷数据、温数据、热数据），每种类型的数据如何处理，热数据如何进行淘汰，这些都是互联网系统常见的问题。通过本方案的学习，将会轻松解决以上问题。',
            },
            {
              title: '物联网设备数据采集方案',
              desc: '使用工业级物联网消息中间件EMQ X实现数据的采集，使用时间序列数据库influxDB实现设备数据的存储。EMQ X 高并发低延时，在全球物联网市场广泛应用。无论是产品原型设计、物联网创业公司、还是大规模的商业部署，EMQ X都支持开源免费使用。',
            },
            {
              title: '数据传递加密混淆解决方案',
              desc: '数据的安全性越来越重要，企业越来越重视数据的安全性，甚至设置专门的数据安全岗位。作为安全体系的一个维度，数据在传递过程中如何防止被窃取，是应用开发中需要考虑的一个问题。本方案采用加密混淆算法，在传递数据的过程中对数据进行加密，获取数据后进行解密，从而有效避免数据传输过程中的安全风险。',
            },
            {
              title: '自动化互联网数据抓取解决方案',
              desc: '互联网是一个宝库，蕴含着海量的数据和商机，互联网数据爬取一直是很多企业必备的技术岗位。本方案采用高并发多线程技术，从目标站点的分析、结构化解析，到持久化存储、查询，完成一整套自动化爬取方案',
            },
            {
              title: '延迟队列解决方案',
              desc: '企业开发中存在这样一个场景，某个功能需要在事件发生之后一段时间后执行，解决这一问题的主流方案是使用消息中间件的延迟队列，不同的消息中间件的延迟队列实现方式不同，例如rabbitMQ 的延迟队列是通过死信交换器和TTL来实现的，本方案采用EMQ本身就提供了更为便捷的延迟队列插件，能够快速、简洁、优雅的实现延迟队列功能。',
            },
            {
              title: '分布式事务解决方案',
              desc: '微服务是当前主流的系统架构和技术规范，在微服务系统中，分布式事务是无法回避、必须要解决的问题之一。 我们采用阿里的分布式事务中间件seata来解决这以问题。seata提供的AT模式提供无侵入自动补偿的事务模式，目前已支持 MySQL、 Oracle 、PostgreSQL和 TiDB的AT模式。',
            },
            {
              title: '分布式锁解决方案',
              desc: '微服务架构中为了解决多个微服务修改同一个对象、造成数据不一致的问题，分布式锁是程序员必备的技能，也是常见的面试问题。本方案采用分布式缓存技术（Redis分片集群）实现分布式锁，同时提供应用层接口，方便程序员开发和使用。',
            },
            {
              title: '分布式任务调度解决方案',
              desc: '业务系统中，经常会遇到需要定制执行和处理的任务，而在微服务体系下，分布式任务是程序员必备的技能之一。本方案采用美团开源的任务调度中间件XXL-job实现。  XXL-job功能强大、开箱即用，支持大型的复杂任务，支持任务分片处理。',
            },
            {
              title: '分布式文件存储解决方案',
              desc: '通常在企业中我们会将一些图片，视频，文档等相关数据存储在对象存储中，以便于数据的存储和快速获取。在过去的一段时间，我们将这部分数据存储在公有云的对象存储服务上，但随着业务的快速发展，我们需要存储一些身份信息用于审核和实名相关的数据，这部分数据较为敏感，因此对于敏感数据的存储我们选择了使用兼容S3协议的开源分布式对象存储Minio来进行自建服务。',
            },
            {
              title: '分布式统一日志处理方案',
              desc: '如同人体对外界事件在大脑中的反映，日志能够实时的如实反映系统的运行情况。微服务体系下，如何处理各个子系统的日志是一个软件系统必不可少的支撑环节，是监控和掌握分布式微服务系统各个组件的关键。在本方案中，我们采用 主流的ELK（Elasticsearch +Logstash + Kibana）来处理微服务架构下的日志，提供统一的日志收集、存储、展现、查询等功能。',
            },
            {
              title: '微服务链路追踪解决方案',
              desc: '在微服务项目中，存在着很多调用链路，当某个链路出现故障、bug、性能等情况时，需要对整个链路进行分析检查，定位问题所在的具体位置，此时就需要用到链路跟踪组件。现在比较流行的链路追踪框架主要有 Zipkin，Pinpoint，SkyWalking，CAT等。本方案采用最新的Skywalking技术实现，从代码侵入、性能、UI等方面均有优异的表现。',
            },
            {
              title: '自动化持续集成解决方案',
              desc: '持续集成（CDCI）是一种运维部署领域的常用实践，也是DevOps的具体应用。具体来讲，团队开发成员经常集成他们的工作，通常每个成员每天至少集成一次，也就意味着每天可能会发生多次集成。每次集成都通过自动化的构建（包括编译，发布，自动化测试）来验证，从而尽早地发现集成错误。本方案采用Jenkins作为持续集成工具，可以构建一个自动化的持续集成环境可以使用它来“自动化”编译、打包、分发部署应用，它兼容ant、maven、gradle等多种第三方构建工具，同时与svn、git能无缝集成，也支持直接与知名源代码托管网站，如github、bitbucket直接集成。',
            },
            {
              title: '基于虚拟技术的容器化方案',
              desc: '云环境云平台是当前一个热点发展方向，各大互联网厂商都在此领域发力，同时引领各中小企业在此领域垂直深耕。本方案基于虚拟化技术，采用容器化Docker技术和沙箱机制，可使你用较少的命令和脚本快速部署应用，一次构建，多处移植使用。，迅速搭建自有的系统环境。',
            },
            {
              title: '单点登录解决方案',
              desc: '单点登录（SSO）是在多个应用系统中，用户只需要登录一次就可以访问所有相互信任的应用系统。CAS 是 Yale 大学发起的一个开源项目，旨在为 Web 应用系统提供一种可靠的单点登录方法。',
            },
            {
              title: '动态网页静态化解决方案',
              desc: '为了解决网站高并发的问题，我们通常会进行一些网页静态化技术生成静态页面，比如freemarker、thymeleaf等。',
            },
          ],
        },
        {
          title: '行业专题解决方案',
          subTitle: '面试的大招，行业大牛必学的技术方案',
          content: [
            {
              title: '物联网设备数据采集方案',
              desc: '2020年，全球物联网设备数量超过100亿台，物联网软硬件和服务的支出超过一万亿美元，倡导万物互联的物联网也成为一个主流热点赛道，本方案针对物联网行业中重要的数据采集环节，使用工业级物联网消息中间件EMQ X实现数据的采集，使用时间序列数据库influxDB实现设备数据的存储。EMQ X 高并发低延时，在全球物联网市场广泛应用。无论是产品原型设计、物联网创业公司、还是大规模的商业部署，EMQ X都支持开源免费使用。',
            },
            {
              title: '高并发红包雨解决方案',
              desc: '相信大家对抢红包都不陌生，红包雨作为重要的网络营销工具，已经广泛应用于各个行业和领域的市场开拓。从技术的角度，红包雨涉及到一个非常重要的技术点：高并发，如何开发一个高并发项目是互联网企业面试时必问的知识点。本方案是一个完整的解决方案级项目，通过本项目的学习，一方面可以直接在企业开发中使用，另外对如何开发高并发程序提供了完整的学习使用教程。',
            },
            {
              title: '即时通讯解决方案',
              desc: '社交领域和企业服务中一个非常重要的模块是即时通讯技术，比如各类交友软件、社区、OA系统，甚至CRM系统。如何在时间紧、预算低的情况下，快速搭建自己的即时通讯软件是很多架构师面临的重要难题。本方案采用环信即时通讯服务，能够在几周之内搭建一个即时通讯App，用户、老板都满意。',
            },
            {
              title: '视频点直播解决方案',
              desc: '当下风口领域是什么？短视频和直播领域无疑能排在前三位，比如目前最火的抖音、快手和各种各样的社交类、直播类软件，都在大量使用视频点播和直播技术。本方案提供了阿里云视频服务对接程序和代码，能够快速搭建视频点直播系统，直接迁移到你的应用中使用。',
            },
            {
              title: '电商平台秒杀解决方案',
              desc: '某宝、某东、某拼、某团、社区电商、打车租车...大大小小的各式各样的电商交易类平台，都有秒杀模块，秒杀作为重要的引流手段，已经是电商交易类系统的标配。秒杀对于技术的要求极高，尤其是高并发、消峰平谷、数据一致性、库存防超卖、反作弊、防刷策略等各个技术，都有比较高的技术要求。双十一最高达到每秒58万笔交易，根据我们秒杀项目压力测试结果，每秒钟超过60万笔交易。通过本项目的学习，无论是招聘面试，还是交易、秒杀等场景的实际开发实现，都能够很好的得到锻炼和实际应用。',
            },
            {
              title: '电商平台支付解决方案',
              desc: '线上购物已经成为年轻人主流的购物方式，全国超过8亿人有过网上购物经历，各行各业都推出各自的电商平台，这些平台中必不可少的一个模块是支付模块。如何做到高并发、无差错，如果使用不同的支付平台或第三方支付通道，这些都是程序员需要考虑的问题。本方案对接多种支付通道，如微信、支付宝、第三方支付通道等，包含支付环境完整的生命周期。方案中的项目代码，作为程序员的积累，可以直接复制到企业项目的研发中，快速实现企业开发需要。',
            },
            {
              title: '电商平台购物车解决方案',
              desc: '很多人都有过网上购物和电商平台使用经历，电商的应用领域非常广泛，只要涉及到交易的行业和业务领域，都会涉及到电商，只要涉及到电商的系统，都需要购物车，所以，通过本方案的学习，能够轻松对各行各业的购物车模块的开发。',
            },
          ],
        },
      ],
      realContBotListDataes: [
        {
          icon: 'icona-icon_lixiang_nor2x1',
          title: '立项文档',
          url: 'https://v.itheima.net/pip-java-index/doc/%E5%93%81%E8%BE%BE%E7%89%A9%E6%B5%81%E7%AB%8B%E9%A1%B9%E6%96%87%E6%A1%A3.pdf ',
        },
        {
          icon: 'icona-icon_yuanxing_nor2x',
          title: '原型线框图',
          url: 'https://pmp-preview.itheima.net/pdwlpm/#id=26o8u3&p=%E9%A6%96%E9%A1%B5_%E5%B7%A5%E4%BD%9C%E5%8F%B0&g=1',
        },
        {
          icon: 'icona-icon_gongnengliebiao_nor2x',
          title: '功能列表',
          url: 'https://v.itheima.net/pip-java-index/doc/%E5%93%81%E8%BE%BE%E7%89%A9%E6%B5%81%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8.pdf',
        },
        {
          icon: 'icona-icon_prd_nor2x',
          title: '产品需求文档',
          url: 'https://v.itheima.net/pip-java-index/doc/%E5%93%81%E8%BE%BE%E7%89%A9%E6%B5%81PRD%E6%96%87%E6%A1%A3.pdf',
        },
        {
          icon: 'icona-icon_ui_nor2x',
          title: 'UI规范',
          url: 'https://v.itheima.net/pip-java-index/doc/%E5%93%81%E8%BE%BE%E7%89%A9%E6%B5%81UI%E8%A7%84%E8%8C%83.pdf',
        },
        {
          icon: 'icona-icon_guifan_nor2x',
          title: 'UI设计稿',
          url: 'https://v.itheima.net/pip-java-index/doc/%E5%93%81%E8%BE%BE%E7%89%A9%E6%B5%81UI%E8%AE%BE%E8%AE%A1%E7%A8%BF.pdf ',
        },
      ],
      floatData: [
        { icon: 'icon iconfont icona-gaofugai2x', title: '高覆盖' },
        { icon: 'icon iconfont icona-gengxin2x', title: '快更新' },
        { icon: 'icon iconfont icona-ziyuan6', title: '真业务' },
        { icon: 'icon iconfont icona-zhenfangan2x', title: '真方案' },
        { icon: 'icon iconfont icona-zhenshizhan2x', title: '真实战' },
      ],
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 26,
        autoplay: true,
        delay: 3000,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      options: {
        slidesPerView: 'auto',
        spaceBetween: 26,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'swiper-button-disabled-class',
        },
      },
      floatPositTop: 0,
      objectListdata: null,
      objectIndex: 0,
      openTag: 0,
      overTag: 0,
      fifthScreen: null,
      sixthScreen: {},
      eighthScreen: null,
      ninthScreen: null,
      bigImageInfo: '',
      itemData: [],
      lodTag2: false,
      lodTag5: false,
      numberA: 50,
      numberB: 40,
      numberC: 15,
      timerNum: { numberA: null, numberB: null, numberC: null },
      baseInfo: {
        baseInfoTitle1: '',
        baseInfoTitle2: '',
        baseInfoDesc1: '',
        baseInfoDesc2: '',
        pVideoUrl: '',
        videoLogoImage: '',
      },
      contTop: 2500,
      floatTag: 0,
      scrollLeft: 0,
      botTop: 0,
    };
  },
  computed: {
    objectInfoData() {
      let data = null;
      if (this.objectListdata) {
        data = this.objectListdata[this.objectIndex];
      }
      return data;
    },
    programCroll() {
      return {
        width: this.objectInfoData.contListDataes.length * 300 + 'px',
        // left: -this.rollItemIndex * 300 + 150 + 'px'
      };
    },
    floatPosit() {
      let pos = { position: 'absolute', top: '0px' };
      if (this.floatPositTop < this.contTop) {
        pos = { position: 'absolute' };
      } else if (
        this.floatPositTop >= this.contTop &&
        this.floatPositTop < this.botTop - 588
      ) {
        pos = { position: 'fixed', top: '98px' };
        if (this.screenWidth >= 1440) {
          pos = { ...pos, left: (this.screenWidth - 1440) / 2 + 'px' };
        }
        if (this.screenWidth <= 1210) {
          pos = { ...pos, left: -this.scrollLeft + 'px' };
        }
      } else {
        pos = { position: 'absolute', top: 'auto', bottom: '170px' };
      }

      return pos;
    },
  },
  created() {
    this.getList(this.listId);
    this.getJavaHomeDataes();
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;
    window.addEventListener('scroll', this.scrollHandle);
    window.addEventListener('resize', this.resizeHandle);
  },
  methods: {
    // 初始化数据获取
    getJavaHomeDataes() {
      // this.$apollo.query({
      //   query: JavaHome,
      // })
      this.$axios
        .post('/api', {
          operationName: 'JavaHome',
          // variables:{
          //     id: 2
          // },
          query: JavaHome,
        })
        .then((res) => {
          const data = res.data.data.javaHome;
          this.bannerInfo = data.FirstScreen;
          this.ninthScreen = data.ninthScreen;
          this.objectListdata = data.objectLists.filter((it) => {
            if (it.isOpen) {
              return it;
            }
          });
          this.rollItemIndex =
            this.objectListdata[0].contListDataes.length >= 3 ? 1 : 0;
        })
        .catch((res) => {
          console.log('JavaHome 请求出错：' + res);
        });
    },
    cutstr(str, ind) {
      return CutString(str, ind);
    },
    openFileHandle(url) {
      if (url) {
        window.open(url, '_blank');
      } else {
        this.dialogVisible = true;
      }
    },
    // bannber 数字跳转
    dataCount(obj, num, end, time, ind) {
      const i = ind ? ind : 1;
      this.timerNum[obj] = setInterval(() => {
        if (num < end) {
          num += i;
        } else if (num == end) {
          clearInterval(this.timerNum[obj]);
        }
        this[obj] = num;
      }, time);
    },
    // 点击跳转到项目详情
    goDetails(item) {
      if (item.url == null) {
        return false;
      }
      // window.sessionStorage.setItem("detailsId", String(item.id));
      // this.$trackEvent(item.name, "点击项目", item.name);
      window.open(item.url, '_blank');
      zhuge.track('java-'+item.title + '项目点击次数', {
        项目名称: (item.title),
      });
    },
    openNewUrl(url) {
      window.open(url, '_blank');
    },
    // java 项目切换
    carouselhandle(ist, ind) {
      let st = ist;
      if (ind != 'undefined' && ind < this.rollItemIndex) {
        st = 'red';
      }
      if (ind && ind == this.rollItemIndex) {
        return false;
      }

      const num = this.objectInfoData.contListDataes.length - 1;
      if (st == 'add') {
        this.rollItemIndex =
          this.rollItemIndex < num
            ? this.rollItemIndex + 1
            : this.rollItemIndex;
      } else {
        this.rollItemIndex =
          this.rollItemIndex == 0 ? 0 : this.rollItemIndex - 1;
      }
    },
    // 窗口变化
    resizeHandle() {
      this.screenWidth = document.body.clientWidth;
      console.log(document.body.clientWidth);
    },
    objectHandle(item, index) {
      this.rollItemIndex = item.contListDataes.length >= 3 ? 1 : 0;
      this.objectIndex = index;
      zhuge.track('java学科首页快速导航-' + item.title, '点击次数', {
        项目名称: (item.title),
      });
    },
    // 滚动浮窗
    scrollHandle() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let scrollLeft =
        window.pageXOffset ||
        document.documentElement.scrollLeft ||
        document.body.scrollLeft;
      this.floatPositTop = scrollTop;
      let magTop = document.querySelector('#scrollTag');
      let aimsId1 = document.querySelector('#scrollTg1');
      let aimsId2 = document.querySelector('#scrollTg2');
      let aimsId3 = document.querySelector('#scrollTg3');
      let aimsId4 = document.querySelector('#scrollTg4');
      let botTop = document.querySelector('#scrollTg8');
      let baseTag = magTop.offsetTop - 100;
      this.botTop = botTop.offsetTop;
      this.contTop = baseTag;
      this.scrollLeft = scrollLeft;
      if (scrollTop >= baseTag && scrollTop <= aimsId1.offsetTop + baseTag) {
        this.floatTag = 0;
      } else if (
        scrollTop >= aimsId1.offsetTop + baseTag &&
        scrollTop < aimsId2.offsetTop + baseTag
      ) {
        this.floatTag = 1;
      } else if (
        scrollTop >= aimsId2.offsetTop + baseTag &&
        scrollTop < aimsId3.offsetTop + baseTag
      ) {
        this.floatTag = 2;
      } else if (
        scrollTop >= aimsId3.offsetTop + baseTag &&
        scrollTop < aimsId4.offsetTop + baseTag
      ) {
        this.floatTag = 3;
      } else if (scrollTop >= aimsId4.offsetTop + baseTag) {
        this.floatTag = 4;
      }
    },
    scrollTagHandle(index) {
      let aimsIdTag = document.querySelector('#scrollTag');
      let aimsId1 = document.querySelector('#scrollTg1');
      let aimsId2 = document.querySelector('#scrollTg2');
      let aimsId3 = document.querySelector('#scrollTg3');
      let aimsId4 = document.querySelector('#scrollTg4');
      let aimsId5 = document.querySelector('#scrollTg5');
      let aimsId6 = document.querySelector('#scrollTg6');
      switch (index) {
        case 0: {
          window.scrollTo({
            top: aimsIdTag.offsetTop - 40,
            behavior: 'smooth',
          });
          break;
        }
        case 1: {
          window.scrollTo({
            top: aimsId1.offsetTop + aimsIdTag.offsetTop - 40,
            behavior: 'smooth',
          });
          break;
        }
        case 2: {
          window.scrollTo({
            top: aimsId2.offsetTop + aimsIdTag.offsetTop - 40,
            behavior: 'smooth',
          });
          break;
        }
        case 3: {
          window.scrollTo({
            top: aimsId3.offsetTop + aimsIdTag.offsetTop - 40,
            behavior: 'smooth',
          });
          break;
        }
        case 4: {
          window.scrollTo({
            top: aimsId4.offsetTop + aimsIdTag.offsetTop - 40,
            behavior: 'smooth',
          });
          break;
        }
        case 5: {
          window.scrollTo({
            top: aimsId5.offsetTop + aimsIdTag.offsetTop - 40,
            behavior: 'smooth',
          });
          break;
        }
        case 6: {
          window.scrollTo({
            top: aimsId6 + aimsIdTag - 40,
            behavior: 'smooth',
          });
          break;
        }
      }
    },
    // 获取 项目列表数据
    getList() {
      // this.$apollo
      //   .query({
      //     query: Contents,
      //     variables: {
      //       subjectID: 1,
      //       isPublish: true,
      //     },
      //   })

      this.$axios
        .post('/api', {
          operationName: 'Contents',
          variables: {
            subjectID: 1,
            isPublish: true,
          },
          query: Contents,
        })
        .then((res) => {
          this.itemData = res.data.data.pContents;
          this.itemData.forEach((item) => {
            switch (item.id) {
              case '11':
                item.src = 'black';
                break;
              case '9':
                item.src = 'suyun';
                break;
              case '6':
                item.src = 'zhiwei';
                break;
              case '13':
                item.src = 'zhiniugu';
                break;
              case '17':
                item.src = 'saas';
                break;
              case '19':
                item.src = 'ihrm';
                break;
              case '15':
                item.src = 'likede';
                break;
              case '20':
                item.src = 'money';
                break;
              case '5':
                item.src = 'health';
                break;
              case '8':
                item.src = 'ice';
                break;
              case '22':
                item.src = 'zhihui';
                break;
              case '21':
                item.src = 'juhe';
                break;
              case '1':
                item.src = 'buy';
                break;
              case '3':
                item.src = 'chong';
                break;
              default:
                item.src = '';
            }
          });
        })
        .catch(() => {});
    },
    showStandardHandl(ind) {
      this.overTag = ind;
    },
    colseStandardHandl() {
      this.overTag = this.openTag;
    },

    handleVideo(url, e) {
      // 由于切换图层原因，传参url为之后一个 所以不可用 将url放到了切换事件中进行更换
      this.baseInfo.pVideoUrl = url;
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(this.baseInfo);
    },
    handleVideoListFirst(url, e) {
      console.log(url);
      this.baseInfo.pVideoUrl = url;
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(this.baseInfo);
    },
    handleVideoList(item, e) {
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenuList.dialogFormV(item);
    },
  },
};
</script>

<style src="./style.scss" rel="stylesheet/scss" lang="scss" scoped></style>
<style lang="scss">
.el-popover {
  line-height: 22px;
  color: #616a72;
}
.javaHomeModular .el-dialog {
  padding: 0px;
  margin-top: 120px !important;
  background: transparent;
  .close_ico {
    background: #fff;
    position: fixed;
    right: 50px;
    top: 50px;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    border: solid 1px rgba(0, 0, 0, 0.5);
  }
  img {
    display: block;
  }
}
.javaHomeModular .swiper-pagination-bullet {
  margin: 0 4px;
}
.javaHomeModular .el-dialog__header {
  display: none;
}
.JavaHomeSwiper {
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    width: 56px !important;
    height: 56px !important;
    background: #1086ff url('./images/img/btn_pic_pre.png') center center
      no-repeat !important;
    background-size: 25px 25px !important;
    border-radius: 50%;
  }
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    width: 56px !important;
    height: 56px !important;
    background: #1086ff url('./images/img/btn_pic_next.png') center center
      no-repeat !important;
    background-size: 25px 25px !important;
    border-radius: 50%;
  }
  .swiper-button-next:hover,
  .swiper-button-prev:hover {
    transform: scale(1.1) !important;
  }
}
@media screen and (min-width: 1480px) {
  .javaHomeModular .srcBox .row .col .blc div {
    margin-bottom: 4px !important;
    width: 125px !important;
  }
}
@media screen and (min-width: 1580px) {
  .javaHomeModular .srcBox .row .col .blc div {
    margin-bottom: 6px !important;
    width: 135px !important;
  }
}
@media screen and (min-width: 1660px) {
  .javaHomeModular .srcBox .row .col .blc div {
    margin-bottom: 8px !important;
    width: 140px !important;
  }
}
@media screen and (min-width: 1760px) {
  .javaHomeModular .srcBox .row .col .blc div {
    margin-bottom: 11px !important;
    width: 155px !important;
  }
}
</style>
